import {gql} from '@apollo/client';
import {client} from '../../../../../graphql/client';
import i18n from "../../../../../i18n";

// TypeScript 接口定义
export interface AccountDeliveryDriverImportFailedRecord {
    phone: string;
    errorMessage: string;
    messageKey?: string;
    details?: string | Record<string, any>; // GraphQL返回的是JSON字符串，需要解析
}

export interface AccountDeliveryDriverImportResponse {
    success: boolean;
    message: string;
    successCount: number;
    failedCount: number;
    failedRecords: AccountDeliveryDriverImportFailedRecord[];
    successAccountIds: number[];
}

const DRIVER_IMPORT_FIELDS = `
    success
    message
    successCount
    failedCount
    failedRecords {
        phone
        errorMessage
        messageKey
        details
    }
    successAccountIds
`;

const BATCH_CREATE_FOR_DSP = gql`
  mutation BatchCreateAccountDeliveryDriverForDsp($objectKey: String!, $language: String!) {
    batchCreateAccountDeliveryDriverForDsp(objectKey: $objectKey, language: $language) {
      ${DRIVER_IMPORT_FIELDS}
    }
  }
`;

const BATCH_CREATE_FOR_CENTRAL = gql`
  mutation BatchCreateAccountDeliveryDriverForCentral($objectKey: String!, $language: String!) {
    batchCreateAccountDeliveryDriverForCentral(objectKey: $objectKey, language: $language) {
      ${DRIVER_IMPORT_FIELDS}
    }
  }
`;

const BATCH_CREATE_FOR_WMS = gql`
  mutation BatchCreateAccountDeliveryDriverForWms($objectKey: String!, $language: String!, $warehouseId: Long!) {
    batchCreateAccountDeliveryDriverForWms(objectKey: $objectKey, language: $language, warehouseId: $warehouseId) {
      ${DRIVER_IMPORT_FIELDS}
    }
  }
`;

const normalizeLanguage = (lang: string | undefined | null): string => {
    if (!lang) return 'en';
    return lang.toLowerCase().split('-')[0];
};

export const batchCreateAccountDeliveryDriverForDsp = async (
    objectKey: string,
): Promise<AccountDeliveryDriverImportResponse> => {
    const language = normalizeLanguage(i18n.resolvedLanguage || i18n.language);
    const result = await client.mutate({
        mutation: BATCH_CREATE_FOR_DSP,
        variables: { objectKey, language }
    });
    return result.data.batchCreateAccountDeliveryDriverForDsp;
};

export const batchCreateAccountDeliveryDriverForCentral = async (
    objectKey: string,
): Promise<AccountDeliveryDriverImportResponse> => {
    const language = normalizeLanguage(i18n.resolvedLanguage || i18n.language);
    const result = await client.mutate({
        mutation: BATCH_CREATE_FOR_CENTRAL,
        variables: { objectKey, language }
    });
    return result.data.batchCreateAccountDeliveryDriverForCentral;
};

export const batchCreateAccountDeliveryDriverForWms = async (
    objectKey: string,
    warehouseId: number,
): Promise<AccountDeliveryDriverImportResponse> => {
    const language = normalizeLanguage(i18n.resolvedLanguage || i18n.language);
    const result = await client.mutate({
        mutation: BATCH_CREATE_FOR_WMS,
        variables: { objectKey, language, warehouseId }
    });
    return result.data.batchCreateAccountDeliveryDriverForWms;
};
